import { walkWidgetPropsTree } from '@juvare/widget-ui/Widget';
/**
 * Sets `modalChildSkipValidate` to true on all provided child widget props and their descendants.
 *
 * @param {WidgetProps<any, any>[]} childProps - Array of child widget props to update.
 * @returns {void}
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setModalChildSkipValidate(childProps) {
    for (const props of childProps) {
        walkWidgetPropsTree(props, (p) => {
            p.internalData.modalChildSkipValidate = true;
        });
    }
}
